var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _path10, _path11, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 22,
    viewBox: "0 0 139 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1122_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 11,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5156 0H39.2595V16.7467H29.5156V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1122_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2595 13.5493V16.7467H36.6888C33.7446 16.7467 31.9352 14.9513 31.9352 12.0044V6.35225H29.5156V3.46525H32.1389L32.1224 0.0275595L35.4928 -9.15527e-05V3.46525H39.1849V6.35225H35.5536V11.5284C35.5536 12.8113 36.2972 13.5493 37.6149 13.5493H39.2595Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1122_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 15,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.46542H14.6885V21.5339H0V3.46542Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1122_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6886 3.46542L8.85586 16.5701C7.2517 20.1702 5.84178 21.534 2.83868 21.534H1.34714V18.3051H2.5997C4.34356 18.3051 4.7964 17.8447 5.6185 15.8367L5.66951 15.7289L0 3.46542H3.93781L7.50794 11.6357L10.8411 3.46542H14.6886Z",
    fill: "#00C66F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4492 10.1063C25.4492 7.95531 23.969 6.46605 21.883 6.46605C19.7965 6.46605 18.3168 7.95531 18.3168 10.1063C18.3168 12.2572 19.7965 13.7465 21.883 13.7465C23.969 13.7465 25.4492 12.2572 25.4492 10.1063ZM14.6489 10.1063C14.6489 6.07699 17.7376 3.08951 21.883 3.08951C26.0076 3.08951 29.117 6.08127 29.117 10.1063C29.117 14.1106 26.0076 17.1226 21.883 17.1226C17.7376 17.1226 14.6489 14.1106 14.6489 10.1063Z",
    fill: "#00C66F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7303 10.1055C66.7303 8.01957 65.1893 6.46566 63.0876 6.46566C60.9855 6.46566 59.4402 8.02385 59.4402 10.1055C59.4402 12.1875 60.9855 13.7457 63.0876 13.7457C65.1893 13.7457 66.7303 12.1918 66.7303 10.1055ZM63.3827 3.08951C67.4131 3.08951 70.3938 6.08127 70.3938 10.1059C70.3938 14.1262 67.4131 17.1425 63.3827 17.1425C61.9967 17.1425 60.739 16.7367 59.7015 16.0244V21.5339H56.0835V3.46533H58.476L59.094 4.67302C60.2305 3.67368 61.7138 3.0899 63.3831 3.0899L63.3827 3.08951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3731 3.39166V6.77911H78.8031C76.7641 6.77911 75.9577 7.67563 75.9577 9.84682V16.7467H72.3394V3.46527H74.6597L75.3028 5.09279C76.256 3.91859 77.465 3.39166 79.1837 3.39166H80.3731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1122_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 0,
    width: 11,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.323 0H118.066V16.7467H108.323V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1122_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.066 13.5493V16.7467H115.496C112.551 16.7467 110.742 14.9513 110.742 12.0044V6.35225H108.323V3.46525H110.946L110.93 0.0275595L114.3 -9.15527e-05V3.46525H117.992V6.35225H114.361V11.5284C114.361 12.8113 115.104 13.5493 116.422 13.5493H118.066Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.895 10.1063C129.895 7.95531 128.415 6.46605 126.329 6.46605C124.243 6.46605 122.762 7.95531 122.762 10.1063C122.762 12.2572 124.243 13.7465 126.329 13.7465C128.415 13.7465 129.895 12.2572 129.895 10.1063ZM119.095 10.1063C119.095 6.07699 122.184 3.08951 126.329 3.08951C130.454 3.08951 133.563 6.08127 133.563 10.1063C133.563 14.1106 130.454 17.1226 126.329 17.1226C122.184 17.1226 119.095 14.1106 119.095 10.1063Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3916 13.0108L99.8864 12.3725C99.9044 13.5552 100.817 14.1456 102.114 14.1456C103.119 14.1456 104.018 13.6943 104.018 12.8067C104.018 11.8989 102.858 11.6236 101.443 11.3891C99.3052 11.0359 96.5858 10.4681 96.5858 7.33803C96.5858 4.82451 98.7394 3.08951 101.97 3.08951C104.999 3.08951 107.051 4.65783 107.307 7.04049L103.901 7.52769C103.887 6.47267 103.141 5.95158 101.88 5.95158C100.754 5.95158 100.089 6.46332 100.089 7.22392C100.089 8.10914 101.231 8.31477 102.621 8.56519C104.804 8.95425 107.591 9.41303 107.591 12.6482C107.591 15.358 105.359 17.1226 101.979 17.1226L101.979 17.1218C99.0043 17.1218 96.9041 15.6291 96.4501 13.3099",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.783 8.65953H91.268C90.7567 7.03591 89.5818 6.15497 87.958 6.15497C86.3472 6.15497 85.2033 7.08771 84.783 8.65953ZM94.2114 13.3197C93.0424 15.67 90.7147 17.1223 87.9584 17.1223C84.0065 17.1223 81.0171 14.0861 81.0171 10.1063C81.0171 6.1059 83.9864 3.0896 87.9584 3.0896C92.0673 3.0896 94.886 6.23364 94.886 10.0592H94.8856C94.8856 10.4101 94.8608 10.761 94.8153 11.1123H84.6881C85.0024 12.9248 86.2028 13.923 87.958 13.923C89.2153 13.923 90.2473 13.3326 90.7967 12.3823L94.2114 13.3197Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0535 8.65953H50.5381C50.0268 7.03591 48.8523 6.15497 47.2285 6.15497C45.6177 6.15497 44.4738 7.08771 44.0535 8.65953ZM53.4819 13.3197C52.3125 15.67 49.9852 17.1223 47.2285 17.1223C43.277 17.1223 40.2876 14.0861 40.2876 10.1063C40.2876 6.1059 43.2569 3.0896 47.2285 3.0896C51.3378 3.0896 54.1565 6.23364 54.1565 10.0592H54.1561C54.1561 10.4101 54.1314 10.761 54.0858 11.1123H43.9582C44.2725 12.9248 45.4733 13.923 47.2285 13.923C48.4854 13.923 49.5174 13.3326 50.0672 12.3823L53.4819 13.3197Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1122_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 13,
    width: 5,
    height: 5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.183 13.7462H138.141V17.7863H134.183V13.7462Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1122_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.141 15.7662C138.141 14.5726 137.319 13.7462 136.162 13.7462C135.004 13.7462 134.183 14.5726 134.183 15.7662C134.183 16.9595 135.004 17.7863 136.162 17.7863C137.319 17.7863 138.141 16.9595 138.141 15.7662Z",
    fill: "#00C66F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.02d0bd4f6ed1d299603670e72914f924.svg";
export { ForwardRef as ReactComponent };